import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogAlertComponent } from '../components/dialog-alert/dialog-alert.component';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const dialogService = inject(DialogService);

  let params = req.params;

  params.keys().forEach(key => {
    const value = params.get(key);
    if (value?.trim() === '') {
      params = params.delete(key);
    }
  });

  req = req.clone({ params });

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (![400, 401].includes(error.status)) {
        dialogService.open(DialogAlertComponent, {
          showHeader: false,
          width: '420px',
          data: {
            icon: 'pi pi-spin pi-cog',
            header: 'common.message.SOMETHING_WENT_WRONG',
            close: 'common.button.ok'
          }
        });
      }

      return throwError(() => error);
    })
  );
};
